var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-page-header width-100 display-flex flex-row flex-justify-space-between"},[_c('div',{staticClass:"height-100 display-flex flex-column flex-justify-space-between"},[_vm._t("left-side"),_vm._t("tabs")],2),_vm._t("right-side")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }